export default __webpack_public_path__ + "static/ross-otto-c08daf116acd784128e79e1b0a067d73.jpg";